import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('auth/reset-password', { token, newPassword });
      setMessage(res.data.message);
      // magari dopo qualche secondo reindirizzi
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error('Error reset password:', error);
      setMessage(error.response?.data?.message || 'Error resetting password');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Reset Password</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input 
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e)=> setNewPassword(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary" type="submit">Update Password</button>
      </form>
    </div>
  );
};

export default ResetPassword;
